import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export default function EmptyOrderSuppliersDialog({
  open,
  supplierNames,
  disabled,
  onCancel,
  onContinue,
}) {
  return (
    <Dialog
      open={open}
      onClose={disabled ? undefined : onCancel}
      aria-labelledby="empty-order-suppliers-title"
      PaperProps={{ sx: { borderRadius: "20px", maxWidth: 500 } }}
    >
      <DialogTitle id="empty-order-suppliers-title" sx={{ color: "primary.900", fontWeight: 900 }}>
        Proveedores sin ítems
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: "neutral.700", fontSize: 14, fontWeight: 600 }}>
          Hay proveedores sin ítems seleccionados: {supplierNames.join(", ")}.
          Se ignorarán si decidís continuar.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button
          type="button"
          onClick={onCancel}
          disabled={disabled}
          sx={{ borderRadius: "20px", textTransform: "none", fontWeight: 800 }}
        >
          Volver a editar
        </Button>
        <Button
          type="button"
          variant="contained"
          onClick={onContinue}
          disabled={disabled}
          sx={{ borderRadius: "20px", textTransform: "none", fontWeight: 800 }}
        >
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
